import { createConfiguration, ServerConfiguration } from 'hotdesk_typescript';
import { RemoteConfigKeys } from '../enum/remote-keys';
import { myPromiseMiddleware } from './middleware/promise.middleware';
import { fetchRemoteConfig } from '@/hotdesk-ui/common-classes/firebase.service';
import { getCookie } from 'cookies-next/client';
import { HttpClientLibrary } from './http-client';

export class ApiConfigration {
    apiURL = process.env.NEXT_PUBLIC_API_URL || '';
    url = '';
    constructor() {}
    async getApiConfig(languageCode: string = 'en', token?: string) {
        this.url = (await fetchRemoteConfig(
            RemoteConfigKeys.HD_TEST_API_URL_KEY,
            'string'
        )) as string;
        let isEnable = (await fetchRemoteConfig(
            RemoteConfigKeys.HD_TEST_API_ENABLE_KEY,
            'boolean'
        )) as boolean;
        this.apiURL =
            (isEnable as boolean) === true && process.env.STAGE === 'stage'
                ? this.url
                : this.apiURL;
        const csrfToken = getCookie('ga') || '';
        const accessToken = getCookie('accessToken') || token || '';

        const authMethods = {
            ...(!!accessToken && {
                Bearer: {
                    tokenProvider: {
                        getToken: () => (accessToken ? accessToken : ''),
                        getCSRF: () => (csrfToken ? csrfToken : '')
                    }
                }
            })
        };
        const baseServer = new ServerConfiguration(this.apiURL, {});
        let httpClient = new HttpClientLibrary();
        return createConfiguration({
            baseServer,
            authMethods,
            httpApi: httpClient,
            promiseMiddleware: [myPromiseMiddleware(languageCode)]
        });
    }
}
